/** The agent cursor's greetings: shortcut tips, where `{keys}`
 *  is the user's own key names in bold and the gesture opens its sentence,
 *  and the launch message: a release highlight or the welcome. */
export default {
  gesturePress: "press {keys}",
  gestureHold: "hold {keys}",
  gestureHoldDrag: "hold {keys} and drag",
  gestureHoldDoubleTap: "hold {hold} and double-tap {keys}",
  gestureDoubleTap: "double-tap {keys}",

  greetHelp: "Hi! How can I help?",
  greetType: "Hi! {gesture} to type to me.",
  greetDictate: "Hi! {gesture} to dictate into any app.",
  greetDraw: "Hi! While I'm listening, {gesture} to draw on your screen.",
  greetWorkspace: "Hi! {gesture} to open your workspace.",
  greetNewChat: "Hi! {gesture} to start a new chat by voice.",
  greetHandsFree: "Hi! {gesture} to talk hands-free.",
  greetHandsFreeCancel: "Hi! {gesture} to talk hands-free. {cancel} to cancel.",
  greetTalk: "Hi! {talk} to talk.",
  greetTalkHold: "Hi! {talk} to talk, or hold it to keep me listening.",
  greetTalkOr: "Hi! {talk} to talk, or {listen} to keep me listening.",

  launchHighlight: "**New:** {text}",
} as const;
